import moment from "moment";
import { THEME } from "../constants";

export const formatDate = (date, format = THEME.DATE_FORMAT_LONG) => {
  return moment(date).add(moment().utcOffset(), "minutes").format(format);
};

export const formatTimeAgo = (date) => {
  return moment(date).add(moment().utcOffset(), "minutes").fromNow();
};
